import React, { FC } from 'react';
import { Form, Modal } from 'react-bootstrap';
import styles from './EditLandscapeDocumentModal.module.css';
import { Button } from '../../atoms';
import cn from 'classnames';
import { LandscapeDocumentResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-document-response.dto';

interface EditLandscapeDocumentModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  document: LandscapeDocumentResponseDto;
  handleOnChange: (document: LandscapeDocumentResponseDto) => void;
  handleEdit: (document: LandscapeDocumentResponseDto) => void;
}

const EditLandscapeDocumentModal: FC<EditLandscapeDocumentModalProps> = ({
  show,
  setShow,
  document,
  handleOnChange,
  handleEdit,
}) => {
  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <div className={cn(styles.modal)}>
        <Modal.Body className={cn(styles.modalBody)}>
          <Form.Group className="mb-3">
            <Form.Label>Document Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter document name"
              onChange={(e) =>
                handleOnChange({ ...document, name: e.target.value })
              }
              value={document.name}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Filename</Form.Label>
            <Form.Label className={cn(styles.fileNameWrapper)}>
              {document.file}
            </Form.Label>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className={cn(styles.modalButtons)}>
          <Button
            className={cn(styles.button)}
            variant="dark"
            onClick={() => handleEdit(document)}
          >
            Save
          </Button>
          <Button
            className={cn(styles.cancelButton)}
            variant="light"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default EditLandscapeDocumentModal;
